import styled from '@emotion/styled';
import { Box, Card } from '@mui/material';
import { shape } from '@mui/system';

export const FormField = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

export const Row = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
    },
}));

export const HalfWidthField = styled(FormField)(({ theme }) => ({
    flex: 1,
    [theme.breakpoints.down('sm')]: {
        width: '100%',
    },
}));

// Admin card with AccountCard.js hover effects (for dynamic/interactive items)
export const AdminCard = styled(Card)(({ theme }) => ({
    position: "relative",
    marginBottom: theme.spacing(2),
    boxShadow: theme.shadows[3],
    borderRadius: shape.borderRadius * 2,
    border: `1px solid ${theme.palette.divider}`,
    background: theme.palette.background.paper,
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    padding: theme.spacing(3),
    overflow: "visible",
    "&:hover": {
        transform: "translateY(-4px)",
        boxShadow: theme.shadows[8],
        borderColor: theme.palette.primary.light,
    },
}));

// Static card without hover effects (for fixed configuration sections)
export const StaticCard = styled(Card)(({ theme }) => ({
    position: "relative",
    marginBottom: theme.spacing(2),
    boxShadow: theme.shadows[1],
    borderRadius: shape.borderRadius * 2,
    border: `1px solid ${theme.palette.divider}`,
    background: theme.palette.background.paper,
    padding: theme.spacing(3),
    overflow: "visible",
}));

export const AdminPageContainer = styled(Box)(({ theme }) => ({
    maxWidth: theme.breakpoints.values.lg,
    width: '100%',
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3),
    },
}));

